import { Box, Button, Card, Checkbox, CircularProgress, FormControlLabel, IconButton, InputAdornment, TextField, Typography, useTheme } from '@mui/material';
import React, { useEffect } from 'react';
import Logo from "assests/SL-POS.svg";
import "./style.css";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import CustomTextField from 'components/Fileds/CustomTextFiled';
import CustomButton from 'components/Fileds/CustomButton';
import CustomLabelForm from 'components/Fileds/CustomLabelForm';
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import { EmailOutlined, LockOutlined, ArrowForwardOutlined } from '@mui/icons-material';

// Namespace prefix for this app's cookies
const COOKIE_PREFIX = "pos_";

const LoginContainer = ({
    showPassword,
    setShowPassword,
    handleSubmit,
    handleChange,
    handleBlur,
    values,
    errors,
    touched,
    setFieldValue,
    isSubmitting,
}) => {
    const theme = useTheme();

    const handleRememberMeChange = (event) => {
        const { checked } = event.target;
        setFieldValue("rememberMe", checked);

        if (checked) {
            const encryptedPassword = CryptoJS.AES.encrypt(
                values.password,
                "secret-key"
            ).toString();
            Cookies.set(COOKIE_PREFIX + "email", values.email, { expires: 7 });
            Cookies.set(COOKIE_PREFIX + "password", encryptedPassword, { expires: 7 });
            Cookies.set(COOKIE_PREFIX + "rememberMe", checked, { expires: 7 });
        } else {
            Cookies.remove(COOKIE_PREFIX + "email");
            Cookies.remove(COOKIE_PREFIX + "password");
            Cookies.remove(COOKIE_PREFIX + "rememberMe");
        }
    };

    useEffect(() => {
        const storedEmail = Cookies.get(COOKIE_PREFIX + "email");
        const storedPassword = Cookies.get(COOKIE_PREFIX + "password");
        const storedRememberMe = Cookies.get(COOKIE_PREFIX + "rememberMe") === "true";

        if (storedRememberMe) {
            setFieldValue("rememberMe", storedRememberMe);
            if (storedEmail) setFieldValue("email", storedEmail);

            if (storedPassword) {
                const bytes = CryptoJS.AES.decrypt(storedPassword, "secret-key");
                const originalPassword = bytes.toString(CryptoJS.enc.Utf8);
                setFieldValue("password", originalPassword);
            }
        }
    }, [setFieldValue]);

    return (
        <Box className="bg-container content-center">

            <Box className="login-container">
                <Card variant="outlined" sx={{ zIndex: 100, padding: '30px', borderRadius: '25px', marginBottom: '20px' }}>
                    <Box className="d-flex justify-content-center">
                        <img src={Logo} alt='logo' width="100px" height="100px" />
                    </Box>
                    <form onSubmit={handleSubmit} noValidate>
                        <Box sx={{ mb: 2 }}>
                            <CustomLabelForm
                                variant="subtitle1"
                                label="Email"
                            />
                            <CustomTextField
                                name="email"
                                startIcon={<EmailOutlined sx={{ fontSize: "20px" }} />}
                                value={values?.email}
                                placeholder='Enter Email'
                                onChange={(e) => setFieldValue('email', e.target.value)}
                                error={touched.email && errors.email}
                                helperText={touched.email && errors.email}
                                onBlur={(e) => {
                                    handleBlur(e);
                                    if (values.rememberMe) {
                                        Cookies.set(COOKIE_PREFIX + "email", e.target.value, { expires: 7 });
                                    }
                                }}
                                InputProps={{
                                    sx: {
                                        borderRadius: "20px !important",
                                    },
                                }}
                            />
                        </Box>
                        <Box sx={{ mb: 1 }}>
                            <CustomLabelForm
                                variant="subtitle1"
                                label="Password"
                            />
                            <CustomTextField
                                name="password"
                                startIcon={<LockOutlined sx={{ fontSize: "20px" }} />}
                                value={values?.password}
                                placeholder='Enter Password'
                                type={showPassword ? "text" : "password"}
                                onChange={(e) => setFieldValue('password', e.target.value.trim())}
                                onBlur={(e) => {
                                    handleBlur(e);
                                    if (values.rememberMe) {
                                        const encryptedPassword = CryptoJS.AES.encrypt(
                                            e.target.value,
                                            "secret-key"
                                        ).toString();
                                        Cookies.set(COOKIE_PREFIX + "password", encryptedPassword, { expires: 7 });
                                    }
                                }}
                                error={touched.password && errors.password}
                                helperText={touched.password && errors.password}
                                endIcon={
                                    <IconButton
                                        onClick={() => setShowPassword(!showPassword)}
                                        onMouseDown={(e) => e.preventDefault()}
                                        sx={{ padding: '0px' }}
                                    >
                                        {showPassword ? <Visibility sx={{ fontSize: "20px" }} /> : <VisibilityOff sx={{ fontSize: "20px" }} />}
                                    </IconButton>
                                }
                                InputProps={{
                                    sx: {
                                        borderRadius: "20px !important",
                                    },
                                }}
                            />
                        </Box>
                        <Box className="remember-container">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        name="rememberMe"
                                        checked={values.rememberMe}
                                        onChange={handleRememberMeChange}
                                    />
                                }
                                label="Remember Me"
                                className="payment-text-color"
                            />
                        </Box>
                        <Box>
                            <CustomButton
                                endIcon={<ArrowForwardOutlined />}
                                fullWidth
                                type="submit"
                                loading={isSubmitting}
                                sx={{ mt: 2 }}
                                className='login-form-btn'
                            >
                                Log In
                            </CustomButton>
                        </Box>
                    </form>
                </Card>

                <Typography variant='subtitle1' className="copy-right-text mt-3" sx={{ fontWeight: 700, fontSize: 13, color: "#ffffffb3 !important" }}>
                    Copyright © {new Date().getFullYear()} Serve-Link. All Rights Reserved.
                    {/* <br /> */}
                </Typography>
            </Box>
        </Box >
    );
};

export default LoginContainer;
